// CommonJS so next.config.js, which Node loads without a bundler, can read the
// DSN for the CSP report URI (config/security-headers.js).

/**
 * The web project's DSN. The browser, server and edge SDKs all report here,
 * and the tunnel (app/monitoring/route.ts) forwards only envelopes for it.
 */
const SENTRY_DSN =
  'https://818fa72f481c58dd5b1f23bb1861daa4@o4510160810934272.ingest.us.sentry.io/4510279492042752'

module.exports = { SENTRY_DSN }
